export type PurchaseNetworkId =
  | 'Base'
  | 'BNB Chain'
  | 'Polygon'
  | 'Optimism'
  | 'Arbitrum'
  | 'Avalanche'
  | 'TRON'
  | 'Solana';

/** Public branded chain logos — avoid webpack SVG import lint flakes in CRA. */
export const PURCHASE_NETWORK_ICONS: Record<PurchaseNetworkId, string> = {
  Base: '/assets/networks/base-branded.svg',
  'BNB Chain': '/assets/networks/bnb-branded.svg',
  Polygon: '/assets/networks/polygon-branded.svg',
  Optimism: '/assets/networks/optimism-branded.svg',
  Arbitrum: '/assets/networks/arbitrum-branded.svg',
  Avalanche: '/assets/networks/avalanche-branded.svg',
  TRON: '/assets/networks/tron-branded.svg',
  Solana: '/assets/networks/solana-branded.svg',
};

export const PURCHASE_NETWORKS: Array<{
  id: PurchaseNetworkId;
  name: string;
  icon: string;
  disabled?: boolean;
  comingSoon?: boolean;
  hidden?: boolean;
}> = [
  { id: 'Base', name: 'Base', icon: PURCHASE_NETWORK_ICONS.Base },
  { id: 'BNB Chain', name: 'BNB Chain', icon: PURCHASE_NETWORK_ICONS['BNB Chain'] },
  { id: 'Polygon', name: 'Polygon', icon: PURCHASE_NETWORK_ICONS.Polygon },
  { id: 'Optimism', name: 'Optimism', icon: PURCHASE_NETWORK_ICONS.Optimism },
  { id: 'Arbitrum', name: 'Arbitrum', icon: PURCHASE_NETWORK_ICONS.Arbitrum },
  { id: 'Avalanche', name: 'Avalanche', icon: PURCHASE_NETWORK_ICONS.Avalanche },
  { id: 'TRON', name: 'TRON', icon: PURCHASE_NETWORK_ICONS.TRON, comingSoon: true, hidden: true },
  { id: 'Solana', name: 'Solana', icon: PURCHASE_NETWORK_ICONS.Solana, comingSoon: true, hidden: true },
];

export const VISIBLE_PURCHASE_NETWORKS = PURCHASE_NETWORKS.filter((network) => !network.hidden);
